import React, { Component } from 'react';
import { Table, Input, Button, Modal, Form, Space, Row, Col, message } from 'antd';
import { PlusOutlined, SaveOutlined, DeleteOutlined,EditOutlined } from '@ant-design/icons';
import { withRouter } from "react-router-dom";
import { API } from "../../API/API";

const initialData = [];

class MasterContractConfig extends Component {
  state = {
    reqData: initialData,
    showNewInputForm: false,
    selectedMemberTypeId: 0,
    isModalVisible: false,
    reqName: '',
    details: [],
    detailName: '',
    detailScore: '',
    selectedRecord: '',
    modalDetails: [],
  };

  getData = () => {
    API.get("/getMasterContractReqList").then((response) => {
      if (response.status === 200) {
        this.setState({
          reqData: response.data.retData[0],
          details: response.data.retData[1],
        });
      }
    });
  };

  componentDidMount() {
    this.getData();
  }
  //save requirement to database
  handleAddRequirement = async () => {
  const { reqName, details, reqData, selectedRecord, modalDetails } = this.state;

  if (!reqName || modalDetails.length === 0) {
    message.error("Шаардагдах мэдээлэл болон Бүрдүүлэх материал/шаардлага байх ёстой.");
    return;
  }

  const newReq = {
    mastercontractreqname: reqName,
    mastercontractreqid: selectedRecord ? selectedRecord.mastercontractreqid : 0,
    materials: modalDetails.map(material => ({
      ...material,
      mastercontractdetailreqname: material.mastercontractdetailreqname,  
      mastercontractdetailscore: material.mastercontractdetailscore,
      detailName: undefined ,
      detailScore: undefined,   
    }))
  };
  
  try {
    const response = await API.post("/saveMasterContractRequirement", newReq);
    if (response.status === 200) {
      this.getData();
       this.setState({
          selectedRecord: '',
          reqName: '',
          modalDetails: [],
          isModalVisible: false,
      });
      message.success("Шаардлагатай мэдээллийг амжилттай хадгаллаа.");
    } else {
      message.error("Хадгалалт амжилтгүй боллоо.");
    }
  } catch (error) {
    console.error("Error saving requirement:", error);
    message.error("Хадгалалт амжилтгүй боллоо.");
  }
};

  // working on modal window only --  add detail to list
  handleAddDetail = () => {
    const { detailName, detailScore, details, selectedRecord } = this.state;
    if (!detailName || !detailScore) return; 

    const newDetail = {
      key: details.length + 1,
      mastercontractdetailreqname: detailName,
      mastercontractdetailscore: detailScore,
      mastercontractreqid: selectedRecord ? selectedRecord.mastercontractreqid: 0,
    };
    this.setState(
      prevState => ({
        modalDetails: [...prevState.modalDetails, newDetail],
        detailName: '',
        detailScore: '',
      }),
      () => {
        console.log("Updated"); 
      }
    );
  };
  
  handleRemoveDetail = (index) => {
    const { modalDetails } = this.state;
    const updatedDetails = [...modalDetails];
    updatedDetails.splice(index, 1);
    this.setState({ modalDetails: updatedDetails });
  };

  handleDelete = (mastercontractreqid) => {
    Modal.confirm({
      title: 'Та энэ шаардлагыг устгахдаа итгэлтэй байна уу?',
      content: 'Устгасан тохиолдолд энэ шаардлага дахин сэргээгдэх боломжгүй.',
      onOk: async () => {
        try {
          const response = await API.get("deleteMasterContractReq?mastercontractreqid=" + mastercontractreqid);
          if (response.status === 200) {
            message.success("Амжилттай устгалаа.");
            this.getData(); 
          }
        } catch (error) {
          message.error("Устгалт амжилтгүй боллоо.");
        }
      },
      onCancel() {
        console.log('Delete canceled');
      },
    });
  };

  // Open Modal in Edit mode
  handleEdit = (record) => {
    const { details } = this.state;
    const relatedDetails = details.filter(detail => detail.mastercontractreqid === record.mastercontractreqid);
    
    this.setState({
        isModalVisible: true,
        selectedRecord: record,
        editMode: true,
        reqName: record.mastercontractreqname,
        modalDetails: relatedDetails,
    });
  };

  render() {
    const { reqName, details, detailName, detailScore, reqData, isModalVisible } = this.state;
    const columns = [
      {
        title: 'Шаардагдах мэдээлэл',
        dataIndex: 'mastercontractreqname',
        key: 'mastercontractreqname',
        
      },
      {
        title: 'Бүрдүүлэх материал, шаардлага, оноо',
        key: 'details',
        render: (_, record) => {
          const relatedDetails = details.filter(detail => detail.mastercontractreqid === record.mastercontractreqid);
          if (relatedDetails.length > 0) {
            return (
              <>
                {relatedDetails.map((detail, idx) => (
                  <Row key={idx} style={{width:'100%'}}>
                    <Col span={10}>{detail.mastercontractdetailreqname}</Col>
                    <Col span={2}>{detail.mastercontractdetailscore}</Col>
                  </Row>
                ))}
              </>
            );
          }
          return null;
      },
      },
      {
        title: 'Action',
        key: 'action',
        render: (_, record) => (
          <Space>
            <Button
              icon={<EditOutlined />}
              onClick={() => this.handleEdit(record)}>
              Засах
            </Button>
            <Button
              icon={<DeleteOutlined />}
              onClick={() => this.handleDelete(record.mastercontractreqid)}
              danger>
              Устгах
            </Button>
          </Space>
        ),
      },
    ];
    return (
      <div className="Container">
        <Row align="middle">
          <Col span={24}>
            <Row style={{ height: 56 }} justify="start" align="middle">
              <Col>
                <div className="HeaderLabel">Мастер гэрээ байгуулах баталгааны хуудас</div>
              </Col>
              <Col><div className="divider"></div></Col>
              <Col>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => this.setState({ isModalVisible: true })}
                >Шаардлага нэмэх</Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <div id="req-list" style={{ marginRight: 15 }}>
          <Table
            columns={columns}
            dataSource={reqData}
            rowKey="key"
            pagination={false}
          />
          {/* Modal for adding record */}
          <Modal
            title="Баталгааны хуудсанд үзүүлэлт нэмэх"
            visible={isModalVisible}
            onCancel={() => this.setState({ isModalVisible: false })}
            footer={null}
            width={600}
          >
            <Form layout="vertical">
              <Form.Item label="Шаардагдах мэдээлэл" required>
                <Input
                  value={reqName}
                  onChange={(e) => this.setState({ reqName: e.target.value })}
                  placeholder="Шаардагдах мэдээллийг оруулна уу"
                />
              </Form.Item>
              {/* Child table */}
              <Form.Item label="Requirements">
                <Space direction="vertical" style={{ width: '100%' }}>
                  <Table
                    columns={[
                      { title: 'Бүрдүүлэх материал, шаардлага', dataIndex: 'name', key: 'name' },
                      { title: 'Эзлэх жин /оноо', dataIndex: 'score', key: 'score' },
                      {
                        title: '',
                        key: 'action',
                        render: (_, record, index) => (
                          <Button type="link" onClick={() => this.handleRemoveDetail(index)}>
                            Устгах
                          </Button>
                        ),
                      },
                    ]}
                    dataSource={this.state.modalDetails.map((detail, idx) => ({
                      key: idx,
                      name: detail.mastercontractdetailreqname,
                      score: detail.mastercontractdetailscore,
                    }))}
                    pagination={false}
                    size="small"
                    style={{ marginBottom: 16 }}
                  />
                  {/* Add sub record */}
                  <Space>
                    <Input
                      value={detailName}
                      onChange={(e) => this.setState({ detailName: e.target.value })}
                      placeholder="Бүрдүүлэх материалын нэрийг оруулна уу"
                    />
                    <Input
                      value={detailScore}
                      onChange={(e) => this.setState({ detailScore: e.target.value })}
                      placeholder="Оноог оруулна уу"
                    />
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={this.handleAddDetail}>Бүрдүүлэх материал нэмэх
                    </Button>
                  </Space>
                </Space>
              </Form.Item>
              <Button type="primary" icon={<SaveOutlined />} onClick={this.handleAddRequirement} style={{ width: '100%' }}>
                Мэдээлэл хадгалах
              </Button>
            </Form>
          </Modal>
        </div>
      </div>
    );
  }
}

export default MasterContractConfig;
